import React from "react";

const Failure: React.FC = () => {
    return <>
        <h1> 404 </h1>
    </>;
};

export default Failure;